import React from 'react'
import ReactDOM from 'react-dom'

export default function Modal({ isOpen, setIsOpen, title, children }) {
    const changeIsOpen = () => setIsOpen(!isOpen)

    if (!isOpen) return null

    return ReactDOM.createPortal(
        <div className="fixed inset-0 z-[60] flex items-center justify-center w-full p-4">
            <div onClick={changeIsOpen} className="bg-ink-900/60 backdrop-blur-sm fixed inset-0 z-[60] animate-fade-in"></div>

            <div className="relative w-full max-w-2xl max-h-[90vh] z-[61] animate-scale-in flex flex-col">
                <div className="relative bg-white rounded-2xl shadow-pop flex flex-col max-h-[90vh] overflow-hidden">

                    <div className="flex items-center justify-between gap-3 px-5 sm:px-6 py-3.5 border-b border-gray-100 bg-gradient-to-r from-brand-50 to-white shrink-0">
                        <h3 className="font-display text-lg font-bold text-gray-900">{title}</h3>
                        <button onClick={changeIsOpen} type="button" className="grid place-items-center text-gray-400 hover:bg-gray-100 hover:text-gray-700 rounded-lg w-8 h-8 transition">
                            <svg className="w-3.5 h-3.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                            </svg>
                            <span className="sr-only">Close</span>
                        </button>
                    </div>

                    <div className="overflow-y-auto">
                        {children}
                    </div>
                </div>
            </div>
        </div>,
        document.body
    )
}